import type { KeyboardEvent } from "react";

/** Enter submits; Shift+Enter inserts a newline. Plain Enter never inserts when not submitting. */
export function onAiChatComposerKeyDown(
  e: KeyboardEvent<HTMLTextAreaElement>,
  opts: { canSubmit: boolean; onSubmit: () => void }
): void {
  if (e.key !== "Enter" || e.shiftKey) return;
  e.preventDefault();
  if (opts.canSubmit) opts.onSubmit();
}
